import { Form, Select, SelectProps } from 'antd';
import { Rule } from 'antd/es/form';

type CustomChoiceProps = {
  width?: string;
  title?: string;
  required?: boolean;
  height?: string;
  name?: string | (string | number)[];
  rule?: Rule[];
} & SelectProps;
const Options = ({
  width,
  height,
  value,
  title,
  required,
  name,
  rule,

  ...props
}: CustomChoiceProps) => {
  return (
    <div
      className={'custom_select'}
      style={{
        height: height ? height : 58,
        background: props.disabled ? '#e4e4e4' : '#FFFFFF',
        border: '0.5px solid #407FDD',
        borderRadius: '0.375rem',
        cursor: 'pointer',
        width: width ? width : '',
      }}
    >
      <div
        style={{
          color: '#898989',
          fontSize: '10px',
          display: 'flex',
          gap: '4px',
          marginTop: height === '50px' ? 8 : 8,
          marginLeft: 8,
        }}
      >
        <span className="ml-2">{title}</span>
        {required && <span className="has-text-danger">*</span>}
      </div>
      <div className={'custom_option'}>
        {name ? (
          <Form.Item name={name} rules={rule}>
            <Select
              style={{
                width: '100%',
                marginLeft: 5,
                padding: 0,
                marginTop: height === '50px' ? -8 : 0,
                // marginBottom: title ? '16px' : '0px',
                fontSize: '12px',
              }}
              bordered={false}
              suffixIcon={
                <img
                  src="/icons/arrow_select.svg"
                  alt="arrow"
                  className="mb-1 mr-1"
                  style={{ marginTop: -8 }}
                />
              }
              {...props}
            />
          </Form.Item>
        ) : (
          <Select
            style={{
              width: '100%',
              marginLeft: 5,
              padding: 0,
              marginTop: height === '50px' ? -8 : 0,
              marginBottom: title ? '16px' : '0px',
              fontSize: '12px',
            }}
            bordered={false}
            suffixIcon={
              <img
                src="/icons/arrow_select.svg"
                alt="arrow"
                className="mb-1 mr-10"
                style={{ marginTop: -8 }}
              />
            }
            {...props}
          />
        )}
      </div>
    </div>
  );
};

export default Options;
